import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Select} from '@ngxs/store';
import {UserState} from './state/user/user.state';
import {Observable} from 'rxjs';
import {SearchList} from './models/search-list.model';
import {SystemUser} from './models/system-user.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {
    title = 'cm2-front';

    @Select(UserState.userList) userList$: Observable<SearchList<SystemUser>>;

    constructor(
        public translate: TranslateService,
    ) {
        translate.addLangs(['pl']);
        translate.setDefaultLang('pl');
        translate.use('pl');
    }
}
